import { TranslationExtensionInterface } from '../../../extension/interface/translation.extension.interface';

export class BikeleasingBenefitTranslationExtension extends TranslationExtensionInterface {
  moduleName = 'bikeleasing_v2_benefit';

  get translations() {
    return {
      condition: {
        bikeTypes: 'Fahrräder',
        companyCode: 'Firmencode',
        leasingDurationInMonths: 'Leasingdauer',
        agavLegalProtectionLiabilityMandatory: 'Agav notwendig',
        agavLegalProtectionLiabilityPaidBy: 'Agav gezahlt von',
        maxAmountPerEmployee: 'Höchstbetrag',
        maxBikesPerEmployee: 'Maximale Anzahl an Fahrräder',
        conditionGrantAmount: 'Zuschuss',
        byEmployer: 'vom Arbeitgeber',
        inMonths: 'in Monaten',
        availableTypes: 'verfügbare Typen',
        total: 'gesamt',
        perBike: 'pro Fahrrad',
        conditionGrantAmountPercent: 'Arbeitgeberzugschuss(%)',
        conditionMaximumBikePrice: 'Maximalbetrag',
        conditionMinimumBikePrice: 'Minimalbetrag',
        maxNumberBikesPerEmployee: 'Fahrräder',
        agavPremiumMandatory: 'agavPremiumMandatory',
        agavPremiumPaidBy: 'agavPremiumPaidBy',
        agavPremiumPlusMandatory: 'agavPremiumPlusMandatory',
        agavPremiumPlusPaidBy: 'agavPremiumPlusPaidBy',
        inputTaxDeductible: 'inputTaxDeductible',
        inspectionInsuranceMandatory: 'inspectionInsuranceMandatory',
        insurancePremiumMandatory: 'insurancePremiumMandatory',
        insurancePremiumPlusMandatory: 'insurancePremiumPlusMandatory',
        rateWillBeTakenOverCompletely: 'rateWillBeTakenOverCompletely',
        takesOverInspectionInsurance: 'takesOverInspectionInsurance',
        takesOverInsurancePremium: 'takesOverInsurancePremium',
        takesOverInsurancePremiumPlus: 'takesOverInsurancePremiumPlus',
        copied: 'Kopiert!',
      },
      calculatorTitle: 'Leasingrechner',
      calculatorFormType: {
        employee: 'Arbeitnehmer',
        selfemployed: 'Selbstständige',
        official: 'Beamte',
      },
      information: 'Allgemeine Informationen',
      userName: 'Bikeleasing-ID',
      employeeNumber: 'Personalnummer',
      registerNowInfo:
        'Bereit, mit Bikeleasing zu starten und Dein neues Fahrrad auszuwählen?<br>Wenn Du die Voraussetzungen Deines Arbeitgebers erfüllst, dann beantrage Dein Fahrrad direkt über <dealerLink>einen Händler in Deiner Nähe</dealerLink> oder <onlineLink>online</onlineLink>.',
      conditions: 'Konditionen',
      introText:
        'Mit einem Bikeleasing hast Du die Möglichkeit, ein Fahrrad steuerlich begünstigt über Deinen Arbeitgeber zu leasen. Berechne jetzt Deine verbleibenden Kosten!',
      employerSubsidy: 'Arbeitgeberzuschuss',
      employerExtras: { INSPECTION: 'Inspektion wird übernommen', INSURANCE: 'Versicherung wird übernommen' },
      learnMore: 'Mehr erfahren',
      firstHelpGuide: {
        header: 'Dein Bikeleasing',
        text: 'Erfahre mehr zum Bikeleasing und wie Du noch heute damit starten kannst!',
      },
      calculator: { title: 'Kaufpreis Rad', monthlyCost: 'Monatliche Kosten' },
      calculationBasis: {
        title: 'Berechnungsgrundlage',
        text: 'Die berechneten Werte hängen immer von Faktoren wie der Steuerklasse, dem Familienstand oder dem Bundesland ab. Die Rechnung dient lediglich als Leitlinie und stellt keine Steuer- oder Rechtsberatung dar.\n\nUnsere Berechnungsgrundlage: Jahr 2023; 4.000€ Bruttogehalt; Steuerklasse I; keine Kinder; KV 14,6%; Zusatzbeitrag 1,1%; KiSt 8%; Bundesland Bayern, Arbeitgeber übernimmt Versicherung und Inspektion.',
      },
      learnMorePage: {
        continueButton: 'Weiter',
        backButton: 'Zurück',
        finishButton: 'Beenden',
        bikeSupplier: 'Jetzt zu {{platformName}}',
        bikeSupplierFallback: 'Jetzt zu Deinem Anbieter',
        stepOne: {
          title: 'Benutzerkonto erstellen',
          description:
            'Um ein Bikeleasing zu erhalten, musst Du Dich zunächst im Bikeleasing-Portal Deines Arbeitgebers registrieren. Hier kannst Du alle relevanten Informationen einsehen, sowie einen Bikeleasing-Partnerhändler in Deiner Nähe oder online finden.',
        },
        stepTwo: { title: 'Bikeleasing aussuchen', description: 'Suche Dir Dein Wunschrad bei einem der Handelspartner aus.' },
        stepThree: {
          title: 'Angebot erstellen',
          description:
            'Entweder stellt der Händler Deinem Arbeitgeber das Angebot über das Bikeleasing-Portal oder Du beantragst es selbst im Portal.',
        },
        stepFour: {
          title: 'Losradeln',
          description:
            'Nach Bestätigung des Arbeitgebers kannst Du das Fahrrad abholen oder es Dir direkt zusenden lassen. Bitte beachte, dass die Monatsraten automatisch von Deinem Gehalt abgerechnet werden.',
        },
      },
      infoPage: {
        header: 'Infos zu Bikeleasing',
        infoText:
          'Egal, wohin es gehen soll: Das Dienstrad ist das perfekte Verkehrsmittel, um flexibel und nachhaltig von A nach B zu gelangen. Und natürlich profitieren auch noch Deine Gesundheit und Fitness von der täglichen sportlichen Betätigung - eine klare Win-win-Situation.',
        desiredBike:
          'Dein Wunschrad kannst Du Dir nach persönlichem Belieben auswählen, wodurch Dir diverse Hersteller, Marken und Händler als Auswahlmöglichkeiten zur Verfügung stehen. Und dabei kannst Du auch noch richtig sparen: Die Anschaffungskosten sind für Dich durch das Leasing über den Arbeitgeber um bis zu {{discount}}% günstiger als beim herkömmlichen Kauf.',
        howItWorks: {
          name: 'Wie es funktioniert:',
          moreAbout: 'Mehr zu Bikeleasing:',
          info: 'In nur wenigen Schritten zu Deinem persönlichen Dienstrad.',
          infoText:
            'Egal, wohin es gehen soll: Das Dienstrad ist das perfekte Verkehrsmittel, um flexibel und nachhaltig von A nach B zu gelangen. Und natürlich profitieren auch noch Deine Gesundheit und Fitness von der täglichen sportlichen Betätigung - eine klare Win-win-Situation.',
          calculateCosts: 'Berechne hier in der Probonio-App unverbindlich die verbleibenden Kosten Deines Dienstrads.',
          bikeLeasing: 'Wenn Du ein Dienstrad leasen willst, registriere Dich im Bikeleasing-Portal mit dem Firmencode {{companyCode}}.',
          retailPartners:
            'Nutze die Händlerkarte hier in der Probonio-App, um verschiedene Bikeleasing-Partnerhändler in Deiner Nähe oder online zu entdecken und Dein Wunschrad auszusuchen.',
          bikePickUp: 'Dein Dienstrad kannst Du Dir nach der Bestätigung Deines Arbeitgebers direkt abholen oder zusenden lassen.',
          leasingContract: 'Die Informationen Deiner Leasingverträge kannst Du zukünftig digital per App einsehen.',
        },
      },
      paidBy: { title: 'Zahlung durch', Employer: 'Arbeitgeber', Employee: 'Arbeitnehmer' },
      conclusion: { title: 'Abschluss ist', Voluntary: 'Freiwillig', Compulsory: 'Verpflichtend', NotAllowed: 'Nicht erlaubt' },
      contractDetails: 'Vertragdetails {{contractNumber}}',
      contract: {
        status: {
          EMPLOYEE_APPROVAL_REQUIRED: 'Deine Freigabe erforderlich',
          EMPLOYER_APPROVAL_REQUIRED: 'Freigabe Arbeitgeber erforderlich',
          REQUESTED: 'Beantragt',
          CANCELLED_OR_REJECTED: 'Storniert/Abgelehnt',
          BIKE_TRANSFER_REQUIRED: 'Radübergabe erforderlich',
          BIKE_TRANSFER_DONE: 'Radübergabe erfolgt',
          ACTIVE: 'Aktiv',
          EXPIRING: 'Auslaufend',
          FINISHED: 'Beendet',
          BIKE_SHIPPED: 'Fahrrad versandt',
          EMPLOYER_APPROVAL_DONE: 'Arbeitgeber hat bestätigt',
        },
        title: 'Verträge',
        contractNumber: 'Vertragsnummer',
        trailerRecommendedRetailPrice: 'Anhänger UVP',
        recommendedRetailPrice: 'UVP',
        purchasePrice: 'Kaufpreis',
        employerContribution: 'Arbeitgeberzuschuss',
        salaryConversion: 'Gehaltsumwandlung',
        leasingDuration: 'Dauer',
        leasingDurationMonths: '{{leasingDuration}} Monate',
        benefitInKind: 'Geldwerter Vorteil',
        insuranceCoverage: 'Versicherungsschutz',
        startDate: 'Beginn',
        transferDate: 'Übergabe-Datum',
        leasingRate: 'Gehaltsumwandlung',
        endDate: 'Ende',
        brand: 'Marke',
        model: 'Modell',
        frameSize: 'Rahmengröße',
        items: 'Accessories',
        lockBrand: 'Schlossmarke',
        insurance: { wear: 'Verschleiß-Versicherung', inspectionPackage: 'Inspektionspaket' },
        monthlyPayment: '{{monthlyAmount, euro}}/Monat',
      },
      section: { yourAdvantage: 'Dein Vorteil', contract: 'Vertragsdaten', leasing: 'Leasingdaten', bike: 'Fahrraddaten' },
      intervall: '{{start, monthAndYear}} - {{end, monthAndYear}}',
      vendorTabs: { map: 'Händler in der Nähe finden', online: 'Onlinehändler finden' },
      vendorMap: {
        locationSearch: 'Suche nach Standort',
        noResults: 'Keine Standorte gefunden',
        noResultsList: { title: 'Leider keine Ergebnisse gefunden', description: 'Bitte erweitere Deinen Suchradius' },
        enterSearchTerm: 'Suchbegriff eingeben...',
        openWebsite: 'Web',
        navigate: 'Route',
        marker: { distributorTypePremium: 'Bikeleasing-Partnerhändler' },
      },
      vendorOnline: {
        hero: {
          title: 'Einen Bikeleasing-Onlinehändler finden',
          subtitle: 'Möchtest Du Dein Dienstrad online bestellen? \nWir machen es möglich!',
          btnText: 'Bikeleasing Onlinehändler',
        },
        title: 'Unsere Onlinehändler',
        subtitle: 'Hier kannst Du Dein Bikeleasing-Dienstrad online bestellen',
      },
    };
  }
}
